import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DataService } from '../../../services/data.service';
import { FileService } from '../../../services/file.service';
import { PasService } from '../../../services/pas.service';
import { StockService } from '../../../services/stock.service';
import { UploadFilesService } from '../../../services/upload-files.service';
import { IResponse } from '../../Interfaces/iresponse';
import { IuserPermissionsResponse } from '../../Interfaces/iuser';
import { ICompanyUrlFilePresentation } from "../../Interfaces/ifiles";
import { PasGroupService } from '../../../services/pasGroup.service';
import { InventoryService } from '../../../services/Inventory.service';
import { RouterService } from '../../../services/router.service';
import { BackgroundProcessService } from '../../../services/backgroundprocess.service';

@Component({
  selector: 'arnfilesup-data',
  templateUrl: './arnfilesup.component.html',
  styleUrls: ['./arnfilesup.component.css']
})

export class ArnfilesupComponent {
  Permissions: IuserPermissionsResponse[] = [];
  MenuG: IuserPermissionsResponse[] = [];
  permissionsList = null;
  menuGList = new MatTableDataSource;
  urlFiles :ICompanyUrlFilePresentation[] = [];
  selectedFiles: FileList;
  //Es el array que contiene los items para mostrar el progreso de subida de cada archivo
  progressInfo = []
  listNotifies: string[] =[];
  message = '';
  fileName = '';
  fileInfos: Observable<any>;
  processFileInventory = "upurlfileinventoryv1";
  //processFilePas = "";

  processFileInventoryAvailable: boolean = false;
  processFileGroupAvailable: boolean = false;
  processFilePasAvailable: boolean = false;

  timer: any;
  intervalOn: boolean = true;

  constructor(private uploadFilesService: UploadFilesService, private dataService: DataService,
    private _snackBar: MatSnackBar,
    private fileService: FileService,
    private pasService: PasService,
    private inventoryService: InventoryService,
    private stockService: StockService,
    private pasGroupService: PasGroupService,
    private routeparent: RouterService,
    private router: Router,
    private backgroundProcess: BackgroundProcessService,
  ) {
    //this.timer = setInterval(() => this.loadProcessStatus(), 15000);
    this.SetInterval() 
  }

  async ngOnInit() {
    this.permissionsList = new MatTableDataSource<IuserPermissionsResponse>(this.Permissions);
    this.menuGList = new MatTableDataSource<IuserPermissionsResponse>(this.MenuG);
    this.fileInfos = this.uploadFilesService.getFiles();
    this.GetUrlFiles();
  }

  SetInterval() {
    this.intervalOn = true;
    this.timer = setInterval(() => {
      this.loadProcessStatus();
    }, 15000, 15000);

  }

  private async loadProcessStatus()
  {
    for(let item of this.urlFiles) {
        this.backgroundProcess.GetStatus(item.processCode.trim()).subscribe(response => {
          if (response.body.isValid) {
            item.class = "item-card-fileup-running"
            this.NotifyAdd(response.body.resultData.message + " " + response.body.resultData.progress + "/" + response.body.resultData.total);
          }
          else {
            item.class = "item-card-fileup"

          }
          item.running = response.body.isValid;
        })
    }
  }

  CancelProcess(processCode) {
    var confirmDownload = confirm("Desea cancelar el proceso?");
    if (!confirmDownload) return;

    this.backgroundProcess.Cancel(processCode.trim()).subscribe(response => {
      if (response.body.isValid) {
        this.NotifyAdd(response.body.resultData.description);
      }
      else {
        this.NotifyAdd(response.body.error.description);
      }
    })
  }

  GetUrlFiles()
  {
    this.fileService.GetUrlFilesByModule(4).subscribe(results => {
      if (results.body.isValid) {
        for (let item of results.body.resultData) {
          this.urlFiles.push(item);
        }
        for (let item of this.urlFiles) {
          item.class = "item-card-fileup";
        //  item.backColor = "#485367";
        }
      }
    });
  }

  NotifyAdd(notify) {
    this.listNotifies.unshift(notify);
  }
  selectFiles(event) {
    this.progressInfo = [];
    event.target.files.length == 1 ? this.fileName = event.target.files[0].name : this.fileName = event.target.files.length + " archivos";
    this.selectedFiles = event.target.files;
  }

  uploadFiles() {
    this.message = '';
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.upload(i, this.selectedFiles[i]);
    }
  }

  clickMenu(id: number, processCode: string)
  {
    var confirmDownload = confirm("Desea importar los datos?");
    if (!confirmDownload) return;
    switch (processCode)
    {
      case "UPACO":
        this.pasService.UpAlternateCodesUrlFile(id).subscribe(results => {
          if (results.body.isValid) {
            this.NotifyAdd("Códigos alternos: " + results.body.resultData.description);
            this.openSB(results.body.resultData.description);
          }
          else {
            alert(results.body.error.description);
            this.NotifyAdd("Códigos alternos: " + results.body.error.description);
          }
        });
        break;
      case "UPPGR":
        this.pasGroupService.UpUrlFile(id).subscribe(results => {
          if (results.body.isValid) {
            this.NotifyAdd("PAS grupos: " +results.body.resultData.description);
            this.openSB(results.body.resultData.description);
          }
          else {
            alert(results.body.error.description);
            this.NotifyAdd("PAS grupos: " +results.body.error.description);
          }
        });
        break;
      case "UPASA":
        this.pasService.UpUrlFile(id).subscribe(results => {
          if (results.body.isValid) {
            this.NotifyAdd("PAS : " +results.body.resultData.description);
            this.openSB(results.body.resultData.description);
          }
          else {
            this.NotifyAdd("PAS : " +results.body.error.description);
            alert(results.body.error.description);
          }
        });
        break;
      case "UPASC":
        this.inventoryService.UpUrlFile(id).subscribe(results => {
          if (results.body.isValid) {
            this.NotifyAdd("Inventario: "+results.body.resultData.description);
            this.openSB(results.body.resultData.description);
          }
          else {
            this.NotifyAdd("Inventario: " +results.body.error.description)
            alert(results.body.error.description);
          }
        });
        break;
    }
  }

  async upload(index, file) {
    switch (file.name.toUpperCase().substring(0, 3)) {
      case "PAS":
        {
          this.progressInfo[index] = { value: 0, fileName: file.name };
          const formData: FormData = new FormData();
          formData.append('files', file);
          await this.pasService.UpFilePAS(formData).subscribe(results => {
            if (results.body.isValid) {
              this.openSB(results.body.resultData.description);
              this.progressInfo[index].value = 100;
              this.message = results.body.resultData.description;
            }
            else {
              alert("Error");
              this.message = results.body.error.description;
            }
          },
            (e) => {
              alert(e.error)
              this.message = e.error + '. En ' + file.name;
              console.log(e);
            });
          //this.uploadFilesService.upload(file).subscribe(
          //  event => {
          //    if (event.type === HttpEventType.UploadProgress) {
          //      this.progressInfo[index].value = Math.round(100 * event.loaded / event.total);
          //    } else if (event instanceof HttpResponse) {
          //      this.fileInfos = this.uploadFilesService.getFiles();
          //    }
          //  },
          //  err => {
          //    this.progressInfo[index].value = 0;
          //    this.message = 'No se puede subir el archivo ' + file.name;
          // });
          break;
        }
      case "PCC":
        {
          this.progressInfo[index] = { value: 0, fileName: file.name };
          const url = environment.urlAPI;
          const formData: FormData = new FormData();
          formData.append('files', file);
          this.stockService.UpFileStock(formData).subscribe(results => {
            if (results.body.isValid) {
              this.openSB(results.body.resultData.description);
              this.progressInfo[index].value = 100;
              this.message = results.body.resultData.description;
            }
            else {
              alert("Error");
              this.message = results.body.error.description;
            }
          },
            (e) => {
              alert(e.error)
              this.message = e.error + '. En ' + file.name;
              console.log(e);
            });
          break;
        }
      case "PAC":
        {
          this.progressInfo[index] = { value: 0, fileName: file.name };
          const url = environment.urlAPI;

          const formData: FormData = new FormData();
          formData.append('files', file);
          this.dataService.post<IResponse>(url + 'api/file/v1/arionpascomposition', formData).subscribe(results => {
            if (results.ok) {
              this.openSB(results.body.response);
              this.progressInfo[index].value = 100;
              this.message = results.body.response;
            }
            else {
              alert("Error");
              this.message = results.body.response;
            }
          },
            (e) => {
              alert(e.error)
              this.message = e.error + '. En ' + file.name;
              console.log(e);
            });
          break;
        }
      case "PCA":  //codigos alternos
        {
          this.progressInfo[index] = { value: 0, fileName: file.name };
          const url = environment.urlAPI;

          const formData: FormData = new FormData();
          formData.append('files', file);
          this.dataService.post<IResponse>(url + 'api/file/v1/arionpasalternatecodes', formData).subscribe(results => {
            if (results.ok) {
              this.openSB(results.body.response);
              this.progressInfo[index].value = 100;
              this.message = results.body.response;
            }
            else {
              alert("Error");
              this.message = results.body.response;
            }
          },
            (e) => {
              alert(e.error)
              this.message = e.error + '. En ' + file.name;
              console.log(e);
            });
          break;
        }
      default:
        {
          this.message = "El archivo no cumple con las reglas de nombre";
          break;
        }
    }
  }

  //deleteFile(filename: string) {
  //  this.uploadFilesService.deleteFile(filename).subscribe(res => {
  //    this.message = res['message'];
  //    this.fileInfos = this.uploadFilesService.getFiles();
  //  });
  //}

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  addPermission(permission) {
    this.Permissions.push(permission);
    if (permission.type == "G") {
      this.MenuG.push(permission);
    }
  }

  b_gen(link, id) {
    this.router.navigate([link]);
  }

  b_back() {
    let _backRoute = this.routeparent.getBackRoute();
    this.router.navigate([_backRoute], { skipLocationChange: true });
  }

}
